export default "__VITE_ASSET__fffc288a__"